import profilePhoto from './profile_photo.jpg'

export default function ProfilePhoto() {
  return (
    <div className="w-64 h-64 rounded-full overflow-hidden ring-4 ring-primary/20 shadow-2xl shadow-primary/10">
      <img
        src={profilePhoto}
        alt="Viresh Kashetti"
        className="w-full h-full object-cover"
      />
    </div>
  )
}
